import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, PlayCircle, Lock, Brain, Users } from 'lucide-react';
const benefits = [{
  icon: ShieldCheck,
  title: 'Estructura de Negocio Privada',
  description: 'Cómo operar sin marca personal y sin mostrar tu identidad.'
}, {
  icon: PlayCircle,
  title: 'Entrenamientos de Ejecución Directa',
  description: 'Videos y recursos para que aprendas a generar comisiones desde cero.'
}, {
  icon: Lock,
  title: 'Estrategia de Seguridad Digital',
  description: 'Cómo usar herramientas de IA para que nadie sepa quién está detrás del éxito.'
}, {
  icon: Brain,
  title: 'Mentalidad de Súper Afiliado',
  description: 'Aprende a pensar estratégicamente para asegurar el patrimonio de tu familia a largo plazo.'
}, {
  icon: Users,
  title: 'Comunidad de Apoyo',
  description: 'Un espacio seguro donde aprendes de alguien que vive de esto y entiende la importancia de la discreción.'
}];
export function WhatYouGet() {
  return <section className="bg-[#0a0a0a] py-20 border-t border-white/5" data-id="element-173">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-174">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-175">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-176">
            Lo que recibes al unirte a Affiliate Wave
          </h2>
          <div className="w-24 h-1 bg-[#d4a437] mx-auto rounded-full opacity-50" data-id="element-177"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-178">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className={`bg-[#111] border border-white/10 rounded-xl p-8 hover:border-[#d4a437]/50 transition-all duration-300 ${index === 3 ? 'lg:col-start-1 lg:col-end-2 lg:ml-auto lg:w-full' : ''} ${index === 4 ? 'lg:col-start-2 lg:col-end-4 lg:mr-auto lg:w-full lg:max-w-md' : ''}`} data-id="element-179">
              <div className="w-12 h-12 rounded-full bg-[#d4a437]/10 flex items-center justify-center mb-6" data-id="element-180">
                <benefit.icon className="w-6 h-6 text-[#d4a437]" data-id="element-181" />
              </div>
              <h3 className="text-xl font-bold text-white mb-3" data-id="element-182">
                {benefit.title}
              </h3>
              <p className="text-neutral-400 leading-relaxed" data-id="element-183">
                {benefit.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}